import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnvironmentType } from '../models/state';

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  showBackButton: boolean;
  isFirstPage$: BehaviorSubject<boolean>;
  environment: EnvironmentType;
  browserBack: boolean;

  constructor(
  ) {
    this.isFirstPage$ = new BehaviorSubject(true);
  }

  /**
* @description Indicates if the screen size corresponds to a mobile or tablet
*/
  get currentUrl(): string {
    return window?.location?.host;
  }


  /**
  * @description Indicates if the screen size corresponds to a mobile or tablet
  */
  get isMobileOrTablet(): boolean {
    return window.innerWidth < 960;
  }

  /**
   * @description Indicates if the screen size corresponds to a tablet
   */
  get isTablet(): boolean {
    return window.innerWidth > 568;
  }

  /**
   * @description Indicates if the screen size corresponds to a desktop
   */
  get isDesktop(): boolean {
    return window.innerWidth > 960;
  }

  /**
  * @description Indicates if the screen size corresponds to a desktop
  */
  get isMobile(): boolean {
    return !this.isDesktop && !this.isTablet;
  }

  getEnvironment(): EnvironmentType {
    const url = this.currentUrl;
    let environment: EnvironmentType = 'dev';
    if (url.includes('wportalinternoic.')) environment = 'ic';
    if (url.includes('wmapfre.desa.')) environment = 'int';
    if (url.includes('wmapfre.pre.')) environment = 'pre';
    if (url.includes('www.mapfre.es')) environment = 'pro';
    if (url.includes('buscadores.mapfre.es')) environment = 'pro-buscadores';

    return environment;
  }

}
